var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LeafletMap',{ref:"map",attrs:{"zoom-control":false,"scroll-wheel-zoom":false,"attribution-control":false,"layers":_vm.layers,"fit-bounds":_vm.fitBounds,"fit-options":_vm.fitOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }